import { z } from 'zod'

export const BelongMomentStatus = z.enum(['INCOMING', 'OUTGOING', 'PREPARING'])
export type BelongMomentStatus = z.infer<typeof BelongMomentStatus>
